import styled from "styled-components";
import { Heading1Base } from "../shared/Heading";
export const MenuCardLabel = styled(Heading1Base).withConfig({
  displayName: "MenuCardLabel",
  componentId: "sc-11pdrwh-0"
})(["display:flex;flex-direction:row;font-size:larger;margin-bottom:4px;cursor:default;padding:2px;"]);
export const MenuCardLabelSuffix = styled.div.withConfig({
  displayName: "MenuCardLabel__MenuCardLabelSuffix",
  componentId: "sc-11pdrwh-1"
})(["font-size:initial;margin-left:4px;color:#343333;"]);